import React, { ReactNode } from 'react';
import clsx from '@strava/ui/clsx';
import Button from '@strava/ui/Button';
import styles from './AccountAuthButton.module.scss';

import AppleLogo from '@strava/icons/LogosAppleSmall';
import FacebookLogo from '@strava/icons/LogosFacebookSmall';
import GoogleLogo from '@strava/icons/LogosGoogleSmall';
import EmailLogo from '@strava/icons/ActionsEmailNormalSmall';

export type AuthButtonVariantTypes =
  | 'apple'
  | 'email'
  | 'email-orange'
  | 'facebook'
  | 'facebook-blue' // ironically corresponds to the lighter version of the icon
  | 'google';

type AccountAuthButtonProps = {
  children: ReactNode;
  className?: string;
  variant?: AuthButtonVariantTypes;
  onClick?: () => void;
};

const AccountAuthButton = ({
  children,
  onClick,
  variant,
  className,
  ...options
}: AccountAuthButtonProps) => {
  return (
    <Button
      className={clsx(
        styles.authButton,
        variant === 'facebook-blue' && styles.facebookBlue,
        variant === 'email-orange' && styles.emailOrange,
        className
      )}
      type="button"
      onClick={onClick}
      {...options}
    >
      <React.Suspense fallback={<div className={styles.placeholder} />}>
        {variant === 'apple' && <AppleLogo />}
        {variant === 'facebook' && <FacebookLogo fill="#3b5998" />}
        {variant === 'facebook-blue' && <FacebookLogo />}
        {variant === 'google' && <GoogleLogo />}
        {variant === 'email' && <EmailLogo />}
      </React.Suspense>
      {children}
    </Button>
  );
};

export default AccountAuthButton;
